export class Stopwatch {
  private intervalId: number | undefined = undefined;
  private startTime = 0;
  private endCallback: (() => Promise<void>) | undefined = undefined;

  start(
    intervalMs: number,
    intervalCallback?: (elapsedTime: number) => void,
    endCallback?: () => Promise<void>,
    endTimeMs?: number,
  ): void {
    if (this.intervalId === undefined) {
      this.startTime = Date.now();
      this.endCallback = endCallback;

      this.intervalId = window.setInterval(() => {
        const currentTime = Date.now();
        const elapsedTime = currentTime - this.startTime;

        if (intervalCallback) {
          intervalCallback(elapsedTime);
        }

        if (endTimeMs && currentTime >= endTimeMs) {
          this.end();
        }
      }, intervalMs);
    }
  }

  async end(): Promise<void> {
    clearInterval(this.intervalId);
    this.intervalId = undefined;

    if (this.endCallback) {
      await this.endCallback();
    }
  }

  stop(): void {
    clearInterval(this.intervalId);
    this.intervalId = undefined;
  }

  static toSecs(ms: number): number {
    const result = Math.round(ms / 1000);
    return result < 0 ? 0 : result;
  }
}
